mainApp.component('maintenancePlanInventory', {
    templateUrl: '/public/components/configuration/maintenancePlan/maintenance-plan-inventory.component.html',
    bindings: {
        currentPhase: '<',
        model: '<',
        errors: '<',
        changeListener: '&',
        accountId: '<',
        isPopUp: '<',
        filters: '<',
        socketsStatus: '<',
    },
    controller: maintenancePlanInventoryController
});

function maintenancePlanInventoryController($scope, $rootScope, $state, $filter, $timeout){
    const ctrl = this;

    const POSTPONE_TO_MAKE_CHANGES = "The first phase in the maintenance plan will start in less than 48 hours, making changes now might cause inconsistencies. To allow changes please postpone the whole plan by one week.";
    const POSTPONE_AFTER_CHANGES = "The Maintenance Plan is upgrading Sockets. To change the settings for this plan, save the plan and then click Postpone.";
    const DEFAULT_MOVE_TOOLTIP = "Move site to another phase";
    const DEFAULT_UPGRADE_TOOLTIP = "Upgrade now site Sockets";
    const CANT_MOVE_SITE_NO_MORE_PHASES = "Can't move, since no more phases exist";
    const CANT_UPGRADE_SITE = "Can't upgrade site, all Sockets are up to date";

    ctrl.$onInit = function () {
        ctrl.selectedSite = {};
        ctrl.selectedItems = [];
        ctrl.moveTooltip = DEFAULT_MOVE_TOOLTIP;
        ctrl.upgradeTooltip = DEFAULT_UPGRADE_TOOLTIP;
        ctrl.phases = [];

        updateMoveToolTip();
        addSitesIfNeededForNewlyCreatedPhase();
        setDefaultVauesForTable();
    }

    ctrl.$onChanges = function(changes){
        ctrl.tableDataModified = new Date().getTime();
    }

    ctrl.socketInventoryTableConfig = {
        id: "socketInventoryTableConfig_" + ctrl.tableId,
        defer: false,
        pageSize: 10,
        dontGetDataOnLoad: false,
        dataURL: function() {

            let myFilters = new Map();
            let url = '/getAllSitesByPhase?accountId=' + ctrl.accountId;

            if (!ctrl.isPopUp){
                if (ctrl.currentPhase){
                    myFilters.set('filterByMaintenancePhaseID', [ctrl.currentPhase.id]);
                }

                if (ctrl.socketInventoryTableConfig.sitesToFilter.length > 0) {
                    myFilters.set('sitesToFilter', ctrl.socketInventoryTableConfig.sitesToFilter);
                }
                if (ctrl.socketInventoryTableConfig.sitesToAdd.length  > 0) {
                    myFilters.set('sitesToAdd', ctrl.socketInventoryTableConfig.sitesToAdd);
                }
            }

            if (ctrl.filters && ctrl.filters.length > 0){
                ctrl.filters.forEach(item => {
                    if (myFilters.get(item.filterType)){
                        myFilters.get(item.filterType).push(item.value);
                    }else{
                        myFilters.set(item.filterType, [item.value]);
                    }
                })
            }

            for (let key of myFilters.keys()) {
                url += '&' + key + '=[' + myFilters.get(key) + ']';
            }

            return url;
        },
        parseData: function(items) {
            let phaseIdToNameMap = _.invert(ctrl.model.phaseNameToIdMap);
            createSocketSerialStatusMap();
            items.forEach(site => {
                // This is used for: if a site was moved but not yet saved, it's details are updated.
                if (ctrl.model.siteIdToPhaseIdMap){
                    let newPhaseId = ctrl.model.siteIdToPhaseIdMap[site.id];
                    if (newPhaseId){
                        site.maintenancePhaseId = newPhaseId;
                        site.maintenancePhaseName = phaseIdToNameMap[newPhaseId];
                    }
                }
                // This is used for to update the sites status if the plan is IN PROGRESS.
                if (ctrl.socketSerialStatusMap.size > 0){
                    let statusPrimary = ctrl.socketSerialStatusMap.get(site.socketSerial);
                    if (statusPrimary){
                        site.upgradeStatus = statusPrimary;
                    }

                    if (site.isHA){
                        let statusSecondary = ctrl.socketSerialStatusMap.get(site.secondarySocketSerial);
                        if (statusSecondary){
                            site.upgradeStatus = statusSecondary;
                        }
                    }
                }
            });
            return items;
        },
        fields: [
            {
                label: 'Site Name',
                path: 'siteName',
                template: '<span class="one-row">{{item.name}}</span>',
                noSort: false
            }, {
                label: 'Site Type',
                path: 'siteType',
                template: '<span>{{item.siteType | capitalize}}</span>',
                noSort: true
            }, {
                label: 'Location',
                path: 'siteLocation',
                template: '<span>{{item.countryName | capitalize}}</span>',
                noSort: true
            }, {
                label: 'Phase',
                path: 'phase',
                template: '<span>{{item.maintenancePhaseName | capitalize}}</span>',
                noSort: true
            },
            {
                label: 'HA',
                path: 'ha',
                template: '<span>{{item.isHA | yesNo}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>',
                noSort: true
            },
            {
                label: 'Socket Type',
                path: 'socketModel',
                template: '<span>{{item.platform | getSiteConnTypeString}}</span>',
                noSort: true
            }, {
                label: 'Status',
                path: 'status',
                template: `
                    <div>
                        <button ng-click='tableConfig.redirectToSocketLastEventPage(item, item.startedAt, item.socketSerial)' data-toggle="tooltip" data-placement="top" title="Show more details in Event Discovery" class="push-btn-left">
                            <span ng-show="!tableConfig.getStatus(item.upgradeStatus)">
                                <svg class="icon-prompt icon icon-{{item.upgradeStatus | isUpgradedToIcon : item.isVersionLowerThanTarget}}">
                                    <use xlink:href="" ng-href="/public/images/icons/main.svg#icon-url-{{item.upgradeStatus | isUpgradedToIcon : item.isVersionLowerThanTarget}}"></use>
                                </svg>
                                <span>{{item.startedAt | isoToDayMonthYear}}</span>
                            </span>
                            <span class="icon-prompt icon icon"></span>
                            {{tableConfig.getStatus(item.upgradeStatus)}}
                        </button>
                    </div>
                    <div>
                        <button ng-if="item.isHA" ng-click='tableConfig.redirectToSocketLastEventPage(item, item.secondaryStartedAt, item.secondarySocketSerial)'  data-toggle="tooltip" data-placement="top" title="Show more details in Event Discovery" class="push-btn-left">
                            <span ng-show="!tableConfig.getStatus(item.secondaryUpgradeStatus)">
                                <svg class="icon-prompt icon icon-{{item.secondaryUpgradeStatus | isUpgradedToIcon : item.isVersionLowerThanTarget}}">
                                    <use xlink:href="" ng-href="/public/images/icons/main.svg#icon-url-{{item.secondaryUpgradeStatus | isUpgradedToIcon : item.isVersionLowerThanTarget}}"></use>
                                </svg>
                                <span>{{item.secondaryStartedAt | isoToDayMonthYear}}</span>
                            </span>
                            <span class="icon-prompt icon icon"></span>
                            {{tableConfig.getStatus(item.secondaryUpgradeStatus)}}
                        </button>
                      </div>
                    </div>`,
                noSort: true
            }, {
                label: 'Version',
                path: 'socketVersion',
                template: `<div>{{item.version}}</div>
                       <div ng-if="item.isHA">{{item.secondaryVersion}}</div>`,
                noSort: true
            }, {
                label: 'Actions',
                path: 'action',
                template: "<button id='inventory-inline-actions-{{item.id}}' ng-click='tableConfig.changeAction(item)'><svg id='icon-more'  class='url-action-button icon icon-{{tableConfig.actionData[item.action].icon}}'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-more'></use></svg></button>",
                noSort: true
            }],
        actions: [],
        selectedItems: [],
        clientSideSearch: false,
        noSearch: true,
        refreshViewItems: false,
        liveFilter: false,
        changeAction: function (item) {
            if (!ctrl.model.isPlanNotEditable) {
                ctrl.selectedSite = item;
                let htmlID = "inventory-inline-actions-" + item.id;
                updateSiteUpgradeToolTip();
                updateMoveToolTip();

                let element = $('#' + htmlID);

                //this correction is needed for when div the button is in is scrolled down
                let scroll = $('.right .nano-slider').offset().top
                let top = element.offset().top;
                let left = element.offset().left;
                let offset = (scroll < 150) ? 0 : scroll-80;

                //the invoker is in a timeout, to let frontend changes to set place and then invoke the popup
                $timeout(function() {
                    $rootScope.$emit("$openPopup", "inventory-inline-actions-" + ctrl.currentPhase.id, htmlID, {rightArrow: true, top: top, left: left, leftMod: -500, topMod: -150+offset});
                }, 1);
            }else{
                $rootScope.alert(POSTPONE_TO_MAKE_CHANGES);
            }
        },
        getStatus: function(upgradeStatus){
            if (upgradeStatus === 'PENDING'){
                return 'Pending';
            }else if(upgradeStatus === 'STARTED'){
                return 'Upgrading';
            } else{
                false;
            }
        },
        sitesToAdd: [],
        sitesToFilter: [],
        redirectToSocketLastEventPage: function (item, upgradeBeginTime, socketSerial) {

            if (!item || !upgradeBeginTime || !socketSerial) return;

            $state.go('app.eventsDiscovery', angular.extend({
                start: moment(upgradeBeginTime).valueOf() - + 1000 * 60 * 60 * 48, //48 hours before
                end: moment(upgradeBeginTime).valueOf() + 1000 * 60 * 60 * 48, // 48 hours after
                query: angular.toJson([
                    {
                        field: 'event_sub_type',
                        operator: 'is',
                        spec: 'mustMatchPhrase',
                        value: 'Socket Upgrade',
                        description: "event sub type is Socket Upgrade"
                    },
                    {
                        field: 'socket_serial',
                        operator: 'is',
                        spec: 'mustMatchPhrase',
                        value: socketSerial,
                        description: 'socketID is ' + socketSerial,
                    },
                ]),
            }, {}))
        },
    }

    ctrl.openPopup = function () {
        let canMove = !ctrl.cannotMoveSite();

        if (canMove){
            updatePhasesArray();
            ctrl.targetPhaseId = ctrl.selectedSite.maintenancePhaseId;
            $rootScope.closePopup("inventory-inline-actions-" + ctrl.currentPhase.id);
            $rootScope.openPopup('changePhase_' + ctrl.currentPhase.id);
        }

    }

    ctrl.closeChangePhasePopup = function () {
        ctrl.socketInventoryTableConfig.selectedItems.push(ctrl.selectedSite)
        ctrl.moveAllCurrentSelectedSites(ctrl.targetPhaseId)
        $rootScope.closePopup('changePhase_' + ctrl.currentPhase.id);
        if (ctrl.model.planStatus === 'IN_PROGRESS'){
            $rootScope.alert(POSTPONE_AFTER_CHANGES);
        }
    }

    ctrl.closeAndCancelPopup = function () {
        $rootScope.closePopup('changePhase_' + ctrl.currentPhase.id);
    }

    ctrl.moveSiteToNewPhase = function (site, targetPhaseId, sitesToMove){
        if (site.maintenancePhaseId !== targetPhaseId){

            //if a site was moved, on the frontend and not yet saved, and now it is moved again
            if (ctrl.model.siteIdToPhaseIdMap[site.id] && ctrl.model.siteIdToPhaseIdMap[site.id] < 0){
                $rootScope.$broadcast('updateRemoveItems', targetPhaseId, ctrl.model.siteIdToPhaseIdMap[site.id], [site]);
            }

            ctrl.model.siteIdToPhaseIdMap[site.id] = targetPhaseId;

            let targetPhase = ctrl.model.maintenancePhases.filter(phase => phase.id === targetPhaseId)[0];
            let oldPhase = ctrl.model.maintenancePhases.filter(phase => phase.id === site.maintenancePhaseId)[0];

            if (targetPhase.id !== oldPhase.id){

                targetPhase.numberOfSites++;
                oldPhase.numberOfSites--;

                updateNumberOfSitesAndSockets(oldPhase, targetPhase, site.upgradeStatus, site.isVersionLowerThanTarget);
                if (site.isHA){
                    updateNumberOfSitesAndSockets(oldPhase, targetPhase, site.secondaryUpgradeStatus, site.isVersionLowerThanTarget);
                }

                site.maintenancePhaseName = targetPhase.name;

                sitesToMove.push(site)
            }
        }
    }

    ctrl.moveAllCurrentSelectedSites = function (targetPhaseId) {
        ctrl.sitesToMove = [];
        ctrl.oldPhaseId;
        ctrl.socketInventoryTableConfig.selectedItems.forEach(site => {
            ctrl.moveSiteToNewPhase(site, targetPhaseId, ctrl.sitesToMove);
            ctrl.oldPhaseId = site.maintenancePhaseId;
            site.maintenancePhaseId = targetPhaseId;
        })
        $rootScope.$broadcast('updateRemoveItems', targetPhaseId, ctrl.oldPhaseId, ctrl.sitesToMove);
        $rootScope.$broadcast('updateSiteItems', targetPhaseId, ctrl.oldPhaseId, ctrl.sitesToMove);
        ctrl.selectedSite = {};
        ctrl.socketInventoryTableConfig.selectedItems = [];
    }

    let updatePhasesArray = function(){
        ctrl.model.maintenancePhases.forEach(phase => {
            let index = ctrl.phases.findIndex(item => item.id === phase.id);
            if (index >= 0) {
                ctrl.phases[index].name = phase.name;
            } else {
                ctrl.phases.push({
                    name: $filter('capitalize')(phase.name.toLowerCase()),
                    id: phase.id,
                    field: {
                        type: 'Any',
                        output: () => {
                            return {'id': phase.id, 'name': 'Any', 'display_name': $filter('capitalize')(phase.name.toLowerCase())};
                        }
                    }
                })
            }
        });

        if (ctrl.model.phasesToDelete.length > 0){
            ctrl.phases = ctrl.phases.filter(phase => !ctrl.model.phasesToDelete.includes(phase.id));
        }
    }

    let updateNumberOfSitesAndSockets = function(oldPhase, targetPhase, upgradeStatus, isVersionLowerThanTarget){
        targetPhase.socketsStatus.total++;
        oldPhase.socketsStatus.total--;

        if (isVersionLowerThanTarget && upgradeStatus === 'SUCCESS'){
            targetPhase.socketsStatus.skip++;
            oldPhase.socketsStatus.skip--;
        }else if (upgradeStatus === 'FAIL' || upgradeStatus === 'SUCCESS' || upgradeStatus == 'SKIP'){
            targetPhase.socketsStatus[upgradeStatus.toLowerCase()]++;
            oldPhase.socketsStatus[upgradeStatus.toLowerCase()]--;
        }else{
            targetPhase.socketsStatus.pending++;
            oldPhase.socketsStatus.pending--;
        }

    }

    let setDefaultVauesForTable = function(){
        if (ctrl.isPopUp){
            ctrl.socketInventoryTableConfig.fields.pop()
            ctrl.socketInventoryTableConfig.pageSize = 5;
        }else{
            ctrl.socketInventoryTableConfig.pageSize = 10;
            _.remove(ctrl.socketInventoryTableConfig.fields, function (field) {return field.label === 'Phase'});
            ctrl.socketInventoryTableConfig.hideCheckboxes = true;
            ctrl.socketInventoryTableConfig.actions = false;
            _.drop(ctrl.socketInventoryTableConfig.fields, 1);
        }
    }

    let createSocketSerialStatusMap = function(){
        ctrl.socketSerialStatusMap = new Map();

        if (ctrl.socketsStatus && ctrl.socketsStatus != 'EMPTY'){
            let planSocketStatus = Object.keys(ctrl.socketsStatus).reduce(function (r, k) {
                return r.concat(ctrl.socketsStatus[k]);
            }, []);

            planSocketStatus.forEach(socket => ctrl.socketSerialStatusMap.set(socket.socketId, socket.status))
        }
    }

    let addSitesIfNeededForNewlyCreatedPhase = function(){
        Object.keys(ctrl.model.siteIdToPhaseIdMap).forEach(siteId => {
            let phaseId = ctrl.model.siteIdToPhaseIdMap[siteId];
            if (phaseId === ctrl.currentPhase.id){
                ctrl.socketInventoryTableConfig.sitesToAdd.push(siteId);
            }
        });
    }

    // send to server request to upgrade socket
    let addSocketsToUpgrade = function(){
        if (!ctrl.selectedSite.isVersionLowerThanTarget){
            return;
        }

        let sockets = [];
        sockets.push(ctrl.selectedSite.socketId);

        if (ctrl.selectedSite.isHA){
            sockets.push(ctrl.selectedSite.secondarySocketId);
        }

        let params = {'upgradeType':'LATEST'};

        // send request to server
        store.save({
            path: "/upgradeSocketVersion",
            data: sockets,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                changeSiteStatusToPending();
                ctrl.socketInventoryTableConfig.refreshViewItems = new Date().getTime();
            }
        });
    }

    let changeSiteStatusToPending = function(){
        ctrl.currentPhase.socketsStatus[ctrl.selectedSite.upgradeStatus.toLowerCase()]--;
        ctrl.selectedSite.upgradeStatus = "PENDING";
        if (ctrl.selectedSite.isHA){
            ctrl.currentPhase.socketsStatus[ctrl.selectedSite.secondaryUpgradeStatus.toLowerCase()]--;
            ctrl.selectedSite.secondaryUpgradeStatus = "PENDING";
        }
        ctrl.currentPhase.socketsStatus.pending++;
    }

    let updateMoveToolTip = function(){
        let moveTooltip = (ctrl.model.maintenancePhases.length - ctrl.model.phasesToDelete.length == 1) ? CANT_MOVE_SITE_NO_MORE_PHASES : DEFAULT_MOVE_TOOLTIP;
        $('.maintenance-plan-wrapper .inline-actions .move').attr('data-original-title', moveTooltip);
    }

    let updateSiteUpgradeToolTip = function(){
        let upgradeTooltip = (ctrl.selectedSite.isVersionLowerThanTarget) ? DEFAULT_UPGRADE_TOOLTIP : CANT_UPGRADE_SITE;
        $('.maintenance-plan-wrapper .inline-actions #upgrade-' + ctrl.selectedSite.id).attr('data-original-title', upgradeTooltip);
    }

    ctrl.openPopupUpgradeDlg = function(){
        if (ctrl.selectedSite.isVersionLowerThanTarget) {
            $rootScope.closePopup("inventory-inline-actions-" + ctrl.currentPhase.id);
            $rootScope.openPopup('upgradeDlg-' + ctrl.selectedSite.id);
        }
    }

    ctrl.closePopupUpgradeDlg = function () {
        $rootScope.closePopup('upgradeDlg-' + ctrl.selectedSite.id);
    }

    ctrl.closeAndUpgradePopup = function(){
        ctrl.closePopupUpgradeDlg();
        addSocketsToUpgrade();
    }

    ctrl.setTargetPhase = function(targetPhaseId,$event){
        $event.stopPropagation();
        ctrl.targetPhaseId = targetPhaseId;
    }

    ctrl.cannotMoveSite = function(){
        updateMoveToolTip();
        return ctrl.model.maintenancePhases.length - ctrl.model.phasesToDelete.length === 1;
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
        ctrl.original = angular.copy(ctrl.model);
        ctrl.tableDataModified = new Date().getTime();
    });

    $scope.$on('closeAndAdd', function (event, data) {
        ctrl.moveAllCurrentSelectedSites(ctrl.currentPhase.id);

        // this is used for a new phase that has no mapping yet
        Object.keys(ctrl.model.phaseNameToIdMap).forEach(key => {
            if(ctrl.model.phaseNameToIdMap[key] === ctrl.currentPhase.id){
                delete ctrl.model.phaseNameToIdMap[key];
            }
        })

        ctrl.model.phaseNameToIdMap[ctrl.currentPhase.name] = ctrl.currentPhase.id;
    });

    $scope.$on('updateSiteItems', function(event, targetPhaseId, oldPhaseId, sites) {
        if (targetPhaseId === ctrl.currentPhase.id) {
            let isPhaseUnsaved = targetPhaseId < 0;
            if (isPhaseUnsaved){
                ctrl.model.phaseNameToIdMap[ctrl.currentPhase.name] = targetPhaseId;
                sites.forEach(site => {ctrl.socketInventoryTableConfig.items.push(site)});
                ctrl.socketInventoryTableConfig.refreshViewItems = new Date().getTime();
            }else{
                sites.forEach(site => {
                    ctrl.socketInventoryTableConfig.sitesToAdd.push(site.id);
                    _.pull(ctrl.socketInventoryTableConfig.sitesToFilter, site.id);
                });
                ctrl.tableDataModified = new Date().getTime();
            }
        }
    });

    $scope.$on('updateRemoveItems', function(event, targetPhaseId, oldPhaseId, sites) {
        if (oldPhaseId === ctrl.currentPhase.id){
            let isPhaseUnsaved = oldPhaseId < 0;
            if (isPhaseUnsaved){
                sites.forEach(site => {_.remove(ctrl.socketInventoryTableConfig.items, (currSite) => currSite.id === site.id)});
                ctrl.socketInventoryTableConfig.refreshViewItems = new Date().getTime();
            }else{
                sites.forEach(site => {
                    ctrl.socketInventoryTableConfig.sitesToFilter.push(site.id);
                    _.pull(ctrl.socketInventoryTableConfig.sitesToAdd, site.id);
                });
                ctrl.tableDataModified = new Date().getTime();
            }
        }
    });


};
